<template>
  <div class="page-content">
    <b-row>
      <b-col md="10">
        <page-breadcrumb title="Products" class="mb-3" />
      </b-col>
    </b-row>
    <b-media>
      <section class="py-3">
        <b-row>
          <b-col cols="10">
            <h2 class="mb-2">Product List</h2>
          </b-col>
          <b-col cols="2">
            <div class="text-center">
              <product-create-form 
                :display_order="total_items"
                @create="createItem"
              />
            </div>
          </b-col>
        </b-row>
      </section>
    </b-media>
    <b-card>
      <product-table :items="products" @getList="getList" />
    </b-card>
    <b-pagination
      class="mt-auto"
      pills
      size="lg"
      align="center"
      v-model="current_page"
      :total-rows="total_items"
      :per-page="items_perpage"
    />
  </div>
</template>

<script>
import service from '../service'
import ProductTable from "./_components/ProductTable.vue"
import ProductCreateForm from './_components/ProductCreateForm.vue'
export default {
  components:{
    ProductTable,
    ProductCreateForm
  },
  data(){
    return{
      products: [],
      total_items: 0,
      current_page: 1,
      items_perpage: 15,
    }
  },
  watch:{
    current_page() {
      this.getList();
    },
  },
  created(){
    this.getList();
  },
  methods:{
    async getList() {
      let response = await service.getList({
        page: this.current_page,
        limit: this.items_perpage,
      });
      if (response.data.type === "DATA") {
        this.products = response.data.data.list;
        this.total_items = response.data.data.total;
      }
    },
    async createItem(){
      this.getList();
    }
  }
}
</script>